import { Injectable } from '@angular/core';
@Injectable()
export class PushNotificationsConstants {
  private appCode: string;
  private apiClientId: string;
  private appLanguage: string;
  private urlServiceWorker: string;
  private deviceApi: string;
  private apiBasePath: string;
  private apiHost: string;
  private authToken: string;
  private jwt: string;
  private sourcePush: string;
  private vapidPublicKey: string;

  constructor() {
    // tslint:disable-next-line:no-string-literal
    this.appCode = window['APP_CODE']; // 'Foreman_App'
    // tslint:disable-next-line:no-string-literal
    this.apiClientId = window['CLIENT_ID']; // 'f624df7f-9b35-41c0-8a41-4854b86c84f1';
    // tslint:disable-next-line:no-string-literal
    this.apiHost = window['API_HOST']; // 'https://uscldcnxapmd01.azure-api.net/';
    // tslint:disable-next-line:no-string-literal
    this.appLanguage = window['LANGUAGE']; // 'es-MX';
    this.authToken = 'Bearer ' + sessionStorage.getItem('auth_token');
    this.jwt = sessionStorage.getItem('jwt');
    this.urlServiceWorker = 'service-worker/push_sw.js';
    this.deviceApi = this.apiHost + 'v5/cm/notifications/devices';
    this.sourcePush = 'postMessageSW';
    this.vapidPublicKey = '';
  }

  public getAppCode(): string {
    return this.appCode;
  }

  public getClientId(): string {
    return this.apiClientId;
  }

  public getApiBasePath(): string {
    return this.apiBasePath;
  }

  public getAppLanguage(): string {
    return this.appLanguage;
  }

  public getAuthToken(): string {
    return this.authToken;
  }

  public getJwt(): string {
    return this.jwt;
  }

  public getUrlSW(): string {
    return this.urlServiceWorker;
  }

  public getDevicesPath(): string {
    return this.deviceApi;
  }

  public getSourcePush(): string {
    return this.sourcePush;
  }

  public getVapidPublicKey(): string {
    return this.vapidPublicKey;
  }

  public setVapidPublicKey(pVapidPublicKey) {
    this.vapidPublicKey = pVapidPublicKey;
  }

  public setUrlSW(urlSW) {
    this.urlServiceWorker = urlSW;
  }
}
